import { Rating, Text, Title } from "@clipboard-health/ui-components";
import { Box, DialogContent, Stack } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { WorkplaceAvatar } from "@src/appV2/redesign/components/WorkplaceAvatar";
import { useState } from "react";

import { type StepAction } from "../types";

export interface RateWorkplaceStepProps {
  facilityName: string;
  facilityPhoto?: string;
  isSubmitting?: boolean;
  onAction: (action: StepAction) => void;
}

export function RateWorkplaceStep(props: RateWorkplaceStepProps) {
  const { facilityName, facilityPhoto, isSubmitting = false, onAction } = props;
  const [selectedRating, setSelectedRating] = useState(0);

  return (
    <>
      <DialogContent sx={{ display: "flex", alignItems: "center" }}>
        <Stack spacing={6} alignItems="center" sx={{ px: 0 }}>
          <WorkplaceAvatar pictureUrl={facilityPhoto} size="large" />

          <Title variant="h3" component="h3" textAlign="center">
            Rate your shift at {facilityName}
          </Title>

          <Text variant="body1" textAlign="center" color="text.secondary">
            Select a rating for your shift experience
          </Text>

          <Box sx={{ pt: 1 }}>
            <Rating
              precision={1}
              value={selectedRating}
              size="large"
              disabled={isSubmitting}
              onChange={(_, value) => {
                // Prevent unselecting a star once selected
                if (value !== null && value > 0) {
                  setSelectedRating(value);
                }
              }}
            />
          </Box>
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        {/* hardcoded height to avoid layout shift "I'll do this later" button gets hidden (DialogContent has vertical centering and stars "jump" elsewise) */}
        <Stack spacing={3} sx={{ width: "100%", height: "100px" }}>
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            isLoading={isSubmitting}
            disabled={selectedRating === 0}
            onClick={() => {
              onAction({
                type: "SUBMIT_RATING",
                rating: selectedRating,
              });
            }}
          >
            Continue
          </LoadingButton>
          {selectedRating === 0 && !isSubmitting && (
            <TextButton
              sx={{ alignSelf: "center" }}
              onClick={() => {
                onAction({ type: "CLOSE_FLOW" });
              }}
            >
              I&apos;ll do this later
            </TextButton>
          )}
        </Stack>
      </DialogFooter>
    </>
  );
}
